"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BlockchainNetwork = exports.SignatureStatus = exports.TransactionStatus = exports.TransferStatus = exports.TransferDirection = exports.EventKind = exports.KeyCurve = exports.KeyScheme = exports.WalletStatus = exports.SignatureKind = exports.TransactionKind = exports.TransferKind = void 0;
// FIXME: Missing documentation for TransferKind
var TransferKind;
(function (TransferKind) {
    // FIXME: Missing documentation for Native
    TransferKind["Native"] = "Native";
    // FIXME: Missing documentation for Erc20
    TransferKind["Erc20"] = "Erc20";
    // FIXME: Missing documentation for Erc721
    TransferKind["Erc721"] = "Erc721";
})(TransferKind = exports.TransferKind || (exports.TransferKind = {}));
// FIXME: Missing documentation for TransactionKind
var TransactionKind;
(function (TransactionKind) {
    // FIXME: Missing documentation for Evm
    TransactionKind["Evm"] = "Evm";
    // FIXME: Missing documentation for Eip1559
    TransactionKind["Eip1559"] = "Eip1559";
    // FIXME: Missing documentation for EvmLegacy
    TransactionKind["EvmLegacy"] = "EvmLegacy";
})(TransactionKind = exports.TransactionKind || (exports.TransactionKind = {}));
// FIXME: Missing documentation for SignatureKind
var SignatureKind;
(function (SignatureKind) {
    // FIXME: Missing documentation for Hash
    SignatureKind["Hash"] = "Hash";
    // FIXME: Missing documentation for Message
    SignatureKind["Message"] = "Message";
    // FIXME: Missing documentation for Eip712
    SignatureKind["Eip712"] = "Eip712";
})(SignatureKind = exports.SignatureKind || (exports.SignatureKind = {}));
// FIXME: Missing documentation for WalletStatus
var WalletStatus;
(function (WalletStatus) {
    // FIXME: Missing documentation for Active
    WalletStatus["Active"] = "Active";
    //Initial state of `AssetAccount` entity, indicating that it’s being created at the moment.
    WalletStatus["Creating"] = "Creating";
    // FIXME: Missing documentation for Failed
    WalletStatus["Failed"] = "Failed";
})(WalletStatus = exports.WalletStatus || (exports.WalletStatus = {}));
// FIXME: Missing documentation for KeyScheme
var KeyScheme;
(function (KeyScheme) {
    // FIXME: Missing documentation for ECDSA
    KeyScheme["ECDSA"] = "ECDSA";
    // FIXME: Missing documentation for EdDSA
    KeyScheme["EdDSA"] = "EdDSA";
})(KeyScheme = exports.KeyScheme || (exports.KeyScheme = {}));
// FIXME: Missing documentation for KeyCurve
var KeyCurve;
(function (KeyCurve) {
    // FIXME: Missing documentation for ed25519
    KeyCurve["ed25519"] = "ed25519";
    // FIXME: Missing documentation for secp256k1
    KeyCurve["secp256k1"] = "secp256k1";
})(KeyCurve = exports.KeyCurve || (exports.KeyCurve = {}));
// FIXME: Missing documentation for EventKind
var EventKind;
(function (EventKind) {
    // FIXME: Missing documentation for NativeTransfer
    EventKind["NativeTransfer"] = "NativeTransfer";
    // FIXME: Missing documentation for Erc20Transfer
    EventKind["Erc20Transfer"] = "Erc20Transfer";
    // FIXME: Missing documentation for Erc721Transfer
    EventKind["Erc721Transfer"] = "Erc721Transfer";
})(EventKind = exports.EventKind || (exports.EventKind = {}));
// FIXME: Missing documentation for TransferDirection
var TransferDirection;
(function (TransferDirection) {
    // FIXME: Missing documentation for In
    TransferDirection["In"] = "In";
    // FIXME: Missing documentation for Out
    TransferDirection["Out"] = "Out";
})(TransferDirection = exports.TransferDirection || (exports.TransferDirection = {}));
// FIXME: Missing documentation for TransferStatus
var TransferStatus;
(function (TransferStatus) {
    // FIXME: Missing documentation for Pending
    TransferStatus["Pending"] = "Pending";
    // FIXME: Missing documentation for Executing
    TransferStatus["Executing"] = "Executing";
    // FIXME: Missing documentation for Broadcasted
    TransferStatus["Broadcasted"] = "Broadcasted";
    // FIXME: Missing documentation for Confirmed
    TransferStatus["Confirmed"] = "Confirmed";
    // FIXME: Missing documentation for Failed
    TransferStatus["Failed"] = "Failed";
    // FIXME: Missing documentation for Rejected
    TransferStatus["Rejected"] = "Rejected";
})(TransferStatus = exports.TransferStatus || (exports.TransferStatus = {}));
// FIXME: Missing documentation for TransactionStatus
var TransactionStatus;
(function (TransactionStatus) {
    // FIXME: Missing documentation for Pending
    TransactionStatus["Pending"] = "Pending";
    // FIXME: Missing documentation for Executing
    TransactionStatus["Executing"] = "Executing";
    // FIXME: Missing documentation for Broadcasted
    TransactionStatus["Broadcasted"] = "Broadcasted";
    // FIXME: Missing documentation for Confirmed
    TransactionStatus["Confirmed"] = "Confirmed";
    // FIXME: Missing documentation for Failed
    TransactionStatus["Failed"] = "Failed";
    // FIXME: Missing documentation for Rejected
    TransactionStatus["Rejected"] = "Rejected";
})(TransactionStatus = exports.TransactionStatus || (exports.TransactionStatus = {}));
// FIXME: Missing documentation for SignatureStatus
var SignatureStatus;
(function (SignatureStatus) {
    // FIXME: Missing documentation for Pending
    SignatureStatus["Pending"] = "Pending";
    // FIXME: Missing documentation for Executing
    SignatureStatus["Executing"] = "Executing";
    // FIXME: Missing documentation for Signed
    SignatureStatus["Signed"] = "Signed";
    // FIXME: Missing documentation for Confirmed
    SignatureStatus["Confirmed"] = "Confirmed";
    // FIXME: Missing documentation for Failed
    SignatureStatus["Failed"] = "Failed";
    // FIXME: Missing documentation for Rejected
    SignatureStatus["Rejected"] = "Rejected";
})(SignatureStatus = exports.SignatureStatus || (exports.SignatureStatus = {}));
// FIXME: Missing documentation for BlockchainNetwork
var BlockchainNetwork;
(function (BlockchainNetwork) {
    // FIXME: Missing documentation for ArbitrumOne
    BlockchainNetwork["ArbitrumOne"] = "ArbitrumOne";
    // FIXME: Missing documentation for ArbitrumGoerli
    BlockchainNetwork["ArbitrumGoerli"] = "ArbitrumGoerli";
    // FIXME: Missing documentation for AvalancheC
    BlockchainNetwork["AvalancheC"] = "AvalancheC";
    // FIXME: Missing documentation for AvalancheCFuji
    BlockchainNetwork["AvalancheCFuji"] = "AvalancheCFuji";
    // FIXME: Missing documentation for Bitcoin
    BlockchainNetwork["Bitcoin"] = "Bitcoin";
    // FIXME: Missing documentation for BitcoinTestnet
    BlockchainNetwork["BitcoinTestnet"] = "BitcoinTestnet";
    // FIXME: Missing documentation for Bsc
    BlockchainNetwork["Bsc"] = "Bsc";
    // FIXME: Missing documentation for BscTestnet
    BlockchainNetwork["BscTestnet"] = "BscTestnet";
    // FIXME: Missing documentation for Ethereum
    BlockchainNetwork["Ethereum"] = "Ethereum";
    // FIXME: Missing documentation for EthereumGoerli
    BlockchainNetwork["EthereumGoerli"] = "EthereumGoerli";
    // FIXME: Missing documentation for EthereumSepolia
    BlockchainNetwork["EthereumSepolia"] = "EthereumSepolia";
    // FIXME: Missing documentation for FantomOpera
    BlockchainNetwork["FantomOpera"] = "FantomOpera";
    // FIXME: Missing documentation for FantomTestnet
    BlockchainNetwork["FantomTestnet"] = "FantomTestnet";
    // FIXME: Missing documentation for Optimism
    BlockchainNetwork["Optimism"] = "Optimism";
    // FIXME: Missing documentation for OptimismGoerli
    BlockchainNetwork["OptimismGoerli"] = "OptimismGoerli";
    // FIXME: Missing documentation for Polygon
    BlockchainNetwork["Polygon"] = "Polygon";
    // FIXME: Missing documentation for PolygonMumbai
    BlockchainNetwork["PolygonMumbai"] = "PolygonMumbai";
    // FIXME: Missing documentation for Ripple
    BlockchainNetwork["Ripple"] = "Ripple";
    // FIXME: Missing documentation for RippleTestnet
    BlockchainNetwork["RippleTestnet"] = "RippleTestnet";
    // FIXME: Missing documentation for Solana
    BlockchainNetwork["Solana"] = "Solana";
    // FIXME: Missing documentation for SolanaDevnet
    BlockchainNetwork["SolanaDevnet"] = "SolanaDevnet";
    // FIXME: Missing documentation for Tron
    BlockchainNetwork["Tron"] = "Tron";
    // FIXME: Missing documentation for TronShasta
    BlockchainNetwork["TronShasta"] = "TronShasta";
    // FIXME: Missing documentation for KeyECDSA
    BlockchainNetwork["KeyECDSA"] = "KeyECDSA";
    // FIXME: Missing documentation for KeyEdDSA
    BlockchainNetwork["KeyEdDSA"] = "KeyEdDSA";
})(BlockchainNetwork = exports.BlockchainNetwork || (exports.BlockchainNetwork = {}));
